module.exports = __webpack_public_path__ + "static/media/logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 171
// module chunks = 1